import { createContext, useContext, useMemo } from 'react'

import { useAppStore } from '@/store/hooks'

import { createAccountsRepository, type AccountsRepository } from '../repository'

/** Provide another implementation here (tests, for example) to replace the API-backed one everywhere. */
export const AccountsRepositoryContext = createContext<AccountsRepository | null>(null)

export function useAccountsRepository(): AccountsRepository {
  const injected = useContext(AccountsRepositoryContext)
  const store = useAppStore()
  const own = useMemo(() => createAccountsRepository(store), [store])
  return injected ?? own
}
